import React from 'react';
import './Footer.scss';
import appImage from '../../img/app.png';
import googleImage from '../../img/play.png';
import LeafImg from '../../img/leaf.svg';
import socialIcon from '../../img/socials.svg';
import telIcon from '../../img/tel.svg';
import footerLogo from '../../img/footerLogo.svg';
function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer__links">
        <div className="footer__links-wrapper">
          <div className="footer__container-column">
            <h6>ИНВЕСТОРУ</h6>
            <ul className="footer-list">
              <li>Брокерское Обслуживание</li>
              <li>Торговая платформа</li>
              <li>Тарифы</li>
              <li>Вопросы и ответы</li>
              <li>Открыть счет</li>
              <li>Пополнить счет</li>
              <li>Типовые формы</li>
              <li>Academy</li>
              <li>Radar</li>
              <li>Журналы</li>
              <li>Веб-платформа</li>
            </ul>
          </div>

          <div className="footer__container-column">
            <h6>БИЗНЕСУ</h6>
            <ul className="footer-list">
              <li>Отчеты ПДО</li>
            </ul>
          </div>

          <div className="footer__container-column">
            <h6>ПИФЫ</h6>
            <ul className="footer-list">
              <li>allGA</li>
              <li>abyROI</li>
              <li>állEM</li>
              <li>harMONEY</li>
              <li>doSTAR</li>
            </ul>
          </div>

          <div className="footer__container-column">
            <h6>ПЕНСИОННЫЕ АКТИВЫ</h6>
            <ul className="footer-list">
              <li>Как это работает?</li>
              <li>Преимущества передачи в АО «Jusan Invest»</li>
              <li>Стратегия инвестирования</li>
              <li>Доходность</li>
              <li>Как перевести в АО «Jusan Invest»?</li>
              <li>Частые вопросы</li>
            </ul>
          </div>

          <div className="footer__container-column">
            <h6>ИНФОРМАЦИЯ</h6>
            <ul className="footer-list">
              <li>О компании</li>
              <li>Руководство</li>
              <li>Финансовая отчетность</li>
              <li>Новости</li>
              <li>Документы</li>
              <div className="flex">
                <li>ESG</li>
                <img classname="leaf-img" src={LeafImg} alt=""></img>
              </div>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-contacts">
        <div className="contacts-flex">
          <div className="footer-left">
            <img className="footer-left-img" src={telIcon} alt=""></img>
            <p className="footer-left-title">+7 (707) 264 40 00</p>
            <div className="social-contact">
              <img
                className="social-contact-icon"
                src={socialIcon}
                alt=""
              ></img>
            </div>
          </div>
          <div className="footer-right">
            <a
              className="footer-logo"
              href="https://play.google.com/store/apps/details?id=kz.jysan.junior.app&hl=ru"
            >
              <img src={googleImage} alt="google" />
            </a>
            <a
              className="footer-logo"
              href="https://apps.apple.com/ru/app/jusan-junior/id1628559106"
            >
              <img src={appImage} alt="app" />
            </a>
          </div>
        </div>
        <hr className="footer-line"></hr>
        <div className="footer-copyright">
          <div classname="footer-copyright__left">
            <div>
              <img
                className="footer-copyright__logo"
                src={footerLogo}
                alt="logofooter"
              />
            </div>
            <div>
              <p className="footer-copyright__title">
                Copyright © Акционерное Общество "First Heartland Jusan Invest"
                2004-2021 • Все права защищены <br></br>Лицензия АРРФР
                №3.2.239/16 от 25.06.2021
              </p>
            </div>
          </div>
          <div className="footer-copyright__right">
            <p>Дисклеймер</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
